import { Col, Container, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import styles from './detail.module.scss';
import { IconContext } from "react-icons";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Bestek } from "@/models/bestek";
import { useEffect, useState } from "react";
import apiService from "@/api-service";
import BestekkenMap from "@/components/bestekken-map/bestekken-map";
import BestekkenList from "@/components/bestek-list/bestek-list";

export default function OvkDetail() {
    const navigate = useNavigate();
    const { id, nummer, naam } = useParams();

    const [ mapBestekken, setMapBestekken ] = useState<Bestek[]>();
    const [ listBestekken, setListBestekken ] = useState<Bestek[]>();
    const [ bestekkenCount, setBestekkenCount ] = useState<number>(0);
    const [ loadingList, setLoadingList ] = useState<boolean>(false);
    const [ loadingMap, setLoadingMap ] = useState<boolean>(false);
    const [ activePage, setActivePage ] = useState<number>(1);
    const [ highlightedBestek, setHighlightedBestek ] = useState<Bestek | null>(null);
    const pageSize: number = 5

    const fetchList = (): void => {
        setLoadingList(true);
        apiService.post<{result: Bestek[], total_count: number}>('/bestek/search', { search_params: { overeenkomst_houder_ids: [id] }, pagesize: pageSize, page: activePage})
            .then(
                (response) => {
                    setListBestekken(response.data.result);
                    setBestekkenCount(response.data.total_count);
                }, console.error
            ).finally(() => setLoadingList(false));
    }

    const fetchMap = (): void => {
        setLoadingMap(true);
        apiService.post<{result: Bestek[], total_count: number}>('/bestek/search', { search_params: { overeenkomst_houder_ids: [id] }, pagesize: 0})
            .then(
                (response) => {
                    setMapBestekken(response.data.result);
                }, console.error
            ).finally(() => setLoadingMap(false));
    }

    useEffect(() => {
        fetchList();
    }, [activePage]);

    useEffect(() => {
        if (!mapBestekken && !loadingMap) {
            fetchMap();
        }
        
    });

    return (
        <>
            <div className={styles.header}>
                <IconContext.Provider value={{size: '40px'}}><MdKeyboardArrowLeft onClick={() => navigate(-1)} /></IconContext.Provider>
                <div className={styles.header_title}>{nummer} - {naam}</div>
            </div>

            <Container fluid>
                <Row>
                    <Col sm={12} md={6}>
                        <div className={styles.main}>
                            <div className={styles.main_partial}>
                                <div className={styles.main_partial_header}>
                                    <h6>Algemene informatie</h6>
                                </div>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td width="40%">Nummer:</td>
                                            <td>{nummer}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%">Naam:</td>
                                            <td>{naam}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%">Aantal bestekken:</td>
                                            <td>{bestekkenCount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Col>

                    {/* Bestek map + list */}
                    <Col sm={12} md={6}>
                        {
                            loadingMap && !loadingList && (
                                <div className={styles.loader}>
                                    <Spinner animation="border" size="sm"></Spinner>
                                    <span className="mt-2">Bestekkenkaart ophalen...</span>
                                </div>
                            )
                        }
                        {
                            mapBestekken && mapBestekken.length > 0 && <BestekkenMap bestekken={mapBestekken} selectedBestek={highlightedBestek} onBestekSelection={(b) => setHighlightedBestek(b)} />
                        }
                        {
                            listBestekken && (
                                <BestekkenList 
                                    openInModal
                                    bestekken={listBestekken}
                                    loading={loadingList}
                                    pageSize={pageSize}
                                    page={activePage}
                                    onPageChange={setActivePage}
                                    totalCount={bestekkenCount}
                                />
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}